import { useQuery } from "@tanstack/react-query";
import { Link, useLocation } from "wouter";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { Button, cn } from "@threadws/jute";
import { meMeOptions } from "../api/generated/@tanstack/react-query.gen";
import { userName } from "../utils/userName";

const LINKS = [
  { label: "Today", href: "/" },
  { label: "Personas", href: "/personas" },
  { label: "Agents", href: "/agents" },
];

const isActive = (href: string, location: string) =>
  href === "/" ? location === "/" : location === href || location.startsWith(`${href}/`);

/**
 * The app's navigation, styled like jute's Sidebar (which can't take Sage's brand or a sign-out
 * button yet). A column on the left from `md` up; a strip across the top below that.
 */
export function SageSidebar() {
  const [location] = useLocation();
  const { logout } = useKindeAuth();
  const { data: me } = useQuery(meMeOptions());

  return (
    <aside className="flex shrink-0 flex-col border-b border-border-subtle bg-surface-canvas-strip font-label md:sticky md:top-0 md:h-screen md:w-60 md:border-r md:border-b-0">
      <div className="px-6 pt-6 pb-4 font-babyblue text-pixel-1 text-text-primary md:pb-7">Sage</div>
      <nav className="flex gap-0.5 overflow-x-auto px-3 pb-3 md:flex-1 md:flex-col md:pb-0">
        {LINKS.map(({ label, href }) => (
          <Link
            key={href}
            href={href}
            aria-current={isActive(href, location) ? "page" : undefined}
            className={cn(
              "rounded-sm px-3.5 py-3 text-sm tracking-wide no-underline outline-none transition-colors duration-200 focus-visible:shadow-focus",
              isActive(href, location)
                ? "bg-accent-soft text-accent-fg"
                : "text-text-secondary hover:text-text-primary",
            )}
          >
            {label}
          </Link>
        ))}
        <button
          type="button"
          onClick={() => logout()}
          className="ml-auto rounded-sm px-3.5 py-3 text-sm tracking-wide text-text-secondary md:hidden"
        >
          Sign out
        </button>
      </nav>
      <div className="hidden flex-col gap-3 border-t border-border-subtle px-6 py-4 md:flex">
        {me && (
          <div className="flex flex-col gap-0.5">
            <div className="text-sm text-text-primary">{userName(me)}</div>
            <div className="truncate text-xs text-text-secondary">{me.email}</div>
          </div>
        )}
        <Button variant="ghost" size="sm" icon="" onClick={() => logout()}>
          Sign out
        </Button>
      </div>
    </aside>
  );
}
